// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanTerminationPropertiesLiteDto } from './IPlanTerminationPropertiesLiteDto';
import {
    IPlanTerminationPropertiesLiteDtoFromJSON,
    IPlanTerminationPropertiesLiteDtoFromJSONTyped,
    IPlanTerminationPropertiesLiteDtoToJSON,
    IPlanTerminationPropertiesLiteDtoToJSONTyped,
} from './IPlanTerminationPropertiesLiteDto';
import type { IPlanYearDto } from './IPlanYearDto';
import {
    IPlanYearDtoFromJSON,
    IPlanYearDtoFromJSONTyped,
    IPlanYearDtoToJSON,
    IPlanYearDtoToJSONTyped,
} from './IPlanYearDto';

/**
 * 
 * @export
 * @interface IPlanLiteDto
 */
export interface IPlanLiteDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanLiteDto
     */
    id?: number;
    /**
     * 
     * @type {IPlanYearDto}
     * @memberof IPlanLiteDto
     */
    plan_year?: IPlanYearDto;
    /**
     * 
     * @type {string}
     * @memberof IPlanLiteDto
     */
    plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanLiteDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanLiteDto
     */
    name_state?: IPlanLiteDtoNameStateEnum;
    /**
     * 
     * @type {string}
     * @memberof IPlanLiteDto
     */
    account_type?: IPlanLiteDtoAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPlanLiteDto
     */
    end_of_coverage_type?: IPlanLiteDtoEndOfCoverageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPlanLiteDto
     */
    account_type_state?: IPlanLiteDtoAccountTypeStateEnum;
    /**
     * 
     * @type {string}
     * @memberof IPlanLiteDto
     */
    plan_status?: IPlanLiteDtoPlanStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IPlanLiteDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanLiteDto
     */
    organization_path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanLiteDto
     */
    deletable?: boolean;
    /**
     * 
     * @type {IPlanTerminationPropertiesLiteDto}
     * @memberof IPlanLiteDto
     */
    termination_properties?: IPlanTerminationPropertiesLiteDto;
    /**
     * 
     * @type {string}
     * @memberof IPlanLiteDto
     */
    funding_method_type?: IPlanLiteDtoFundingMethodTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanLiteDto
     */
    lu_gp_designation_allowed?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IPlanLiteDtoNameStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}
/**
* @export
* @enum {string}
*/
export enum IPlanLiteDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
* @export
* @enum {string}
*/
export enum IPlanLiteDtoEndOfCoverageTypeEnum {
    DO_NOTHING = 'DO_NOTHING',
    DAY_OF_TERMINATION = 'DAY_OF_TERMINATION',
    FIRST_DAY_FOLLOWING_MONTH = 'FIRST_DAY_FOLLOWING_MONTH',
    CUSTOM = 'CUSTOM'
}
/**
* @export
* @enum {string}
*/
export enum IPlanLiteDtoAccountTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}
/**
* @export
* @enum {string}
*/
export enum IPlanLiteDtoPlanStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    READY_FOR_SETUP = 'READY_FOR_SETUP',
    DELETED = 'DELETED',
    PENDING_ACTIVE = 'PENDING_ACTIVE',
    UNDER_UPDATE = 'UNDER_UPDATE',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    TERMINATED = 'TERMINATED',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}
/**
* @export
* @enum {string}
*/
export enum IPlanLiteDtoFundingMethodTypeEnum {
    STANDARD_NOTIONAL = 'STANDARD_NOTIONAL',
    PREFUND_SPENDDOWN = 'PREFUND_SPENDDOWN',
    PREFUND_AND_CONTRIBUTION = 'PREFUND_AND_CONTRIBUTION',
    CONTRIBUTION_ONLY = 'CONTRIBUTION_ONLY'
}


/**
 * Check if a given object implements the IPlanLiteDto interface.
 */
export function instanceOfIPlanLiteDto(value: object): value is IPlanLiteDto {
    return true;
}

export function IPlanLiteDtoFromJSON(json: any): IPlanLiteDto {
    return IPlanLiteDtoFromJSONTyped(json, false);
}

export function IPlanLiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanLiteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'plan_year': json['plan_year'] == null ? undefined : IPlanYearDtoFromJSON(json['plan_year']),
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'name': json['name'] == null ? undefined : json['name'],
        'name_state': json['name_state'] == null ? undefined : json['name_state'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'end_of_coverage_type': json['end_of_coverage_type'] == null ? undefined : json['end_of_coverage_type'],
        'account_type_state': json['account_type_state'] == null ? undefined : json['account_type_state'],
        'plan_status': json['plan_status'] == null ? undefined : json['plan_status'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'deletable': json['deletable'] == null ? undefined : json['deletable'],
        'termination_properties': json['termination_properties'] == null ? undefined : IPlanTerminationPropertiesLiteDtoFromJSON(json['termination_properties']),
        'funding_method_type': json['funding_method_type'] == null ? undefined : json['funding_method_type'],
        'lu_gp_designation_allowed': json['lu_gp_designation_allowed'] == null ? undefined : json['lu_gp_designation_allowed'],
    };
}

export function IPlanLiteDtoToJSON(json: any): IPlanLiteDto {
    return IPlanLiteDtoToJSONTyped(json, false);
}

export function IPlanLiteDtoToJSONTyped(value?: IPlanLiteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'plan_year': IPlanYearDtoToJSON(value['plan_year']),
        'plan_code': value['plan_code'],
        'name': value['name'],
        'name_state': value['name_state'],
        'account_type': value['account_type'],
        'end_of_coverage_type': value['end_of_coverage_type'],
        'account_type_state': value['account_type_state'],
        'plan_status': value['plan_status'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'deletable': value['deletable'],
        'termination_properties': IPlanTerminationPropertiesLiteDtoToJSON(value['termination_properties']),
        'funding_method_type': value['funding_method_type'],
        'lu_gp_designation_allowed': value['lu_gp_designation_allowed'],
    };
}

